<template>
  <v-row v-bind:style="{ 'min-width': collapse ? null : '400px' }">

    <buy-subscription-dialog
      v-if="buySubscription"
      :code="buySubscription"
      :tier="tier"
      :value="true"
      @purchase="$emit('purchase')"
      @input="buySubscription = null"
    />

    <div v-if="collapse" class="pt-3 btn-group mx-auto">
      <v-btn class="btn-group-right" :input-value="key == 'SINGLE-USER'" @click="key = 'SINGLE-USER'">Single-user</v-btn>
      <v-btn class="btn-group-left" :input-value="key == 'MULTI-USER'" @click="key = 'MULTI-USER'">Multi-user</v-btn>
    </div>

    <v-col v-if="!collapse || key == 'SINGLE-USER'" class="flex-grow-1 pb-16" :cols="collapse ? 12 : 6">
      <v-card
        class="fill-height relative white--text text-center d-flex flex-column"
        hover color="teal lighten-5"
        @click="buySubscription = 'SINGLE-USER'"
      >
        <div class="pa-3 teal">
          <div class="title font-weight-bold">Single-user</div>
          <div class="text--label-active warning--text text--lighten-3">No business tools</div>
          <!--
          <div class="py-3">
            <price class="text-h5 font-weight-bold" color="white" value="5" per="month" />
            <br>
            <price class="font-weight-bold" color="white" value="30" per="year" />
            <v-chip class="ml-1 absolute px-2" style="pointer-events: none;" label dark small color="red">
              -50%
            </v-chip>
          </div>
          <div style="height: 69px;"></div>
          -->
          <div class="py-3">
            <price class="text-h5 font-weight-bold" color="white" value="35" per="year" />
          </div>
          <div style="height: 91px;"></div>
        </div>

        <div class="absolute text-center pa-2" style="width: 100%; top: 100%;">
          <v-btn color="primary">Select</v-btn>
        </div>

        <v-card-text class="pa-0">
          <div v-if="!hideDescription" class="pa-3 teal darken-2 white--text"><b>Unlimited</b> cards, invitations, and videos</div>
          <template v-if="showDetails">
            <v-divider />
            <div class="px-3 py-6">
              <div class="">Includes personal cards, group cards, and event invitations</div>
              <div class="mt-6">Includes group videos</div>
              <div class="mt-6">Up to 500 recipients for every order</div>
              <div class="mt-6">Unlimited contributors to group cards and videos</div>
            </div>
          </template>
          <div v-else class="pa-3">
            <router-link @click.stop :to="{ name: 'pricing', hash: '#subscriptions' }">Learn more…</router-link>
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col v-if="!collapse || key == 'MULTI-USER'" class="flex-grow-1 pb-16" :cols="collapse ? 12 : 6">
      <v-card
        class="fill-height relative white--text text-center"
        hover color="green lighten-5"
        v-bind="tier == '> 250' ? { href: 'mailto:contact@ellacard.com' } : {}"
        v-on="tier == '> 250' ? {} : { click: () => buySubscription = 'MULTI-USER' }"
      >
        <div class="pa-3 green">
          <div class="title font-weight-bold">Multi-user</div>
          <div class="text--label-active white--text">Includes business tools</div>
          <div v-if="tier == '> 250'" class="py-3 mx-n2 white--text" style="height: 83px;">
            <span  class="text-h5 font-weight-bold">Contact us</span>
            <br>
            <span class="text-body-2">contact@ellacard.com</span>
          </div>
          <div v-else class="py-3">
            <price class="text-h5 font-weight-bold" color="white" :value="monthly" per="month" />
            <br>
            <price class="font-weight-bold" color="white" :value="monthly * 12 * .5" per="year" />
            <v-chip class="ml-1 absolute px-2" style="pointer-events: none;" label dark small color="red">
              -50%
            </v-chip>
          </div>

          <div class="text--label-active white--text text-center mb-1">Number of shared users</div>
          <div @click.stop.prevent>
            <v-select
              class="mx-auto mb-3" style="max-width: 180px;"
              dense hide-details solo right aria-label="Number of shared users"
              :items="TIERS"
              v-model="tier"
            />
          </div>
        </div>

        <div class="absolute text-center pa-2" style="width: 100%; top: 100%;">
          <v-btn color="primary">{{tier == '> 250' ? 'Contact us' : 'Select'}}</v-btn>
        </div>

        <v-card-text class="pa-0">
          <div v-if="!hideDescription" class="pa-3 green darken-2 white--text"><b>Unlimited</b> cards, invitations, and videos</div>
          <template v-if="showDetails">
            <v-divider />
            <div class="px-3 py-6">
              <div class="mb-6">All features from single-user plan</div>
              <div>Share access with managed users</div>
              <div class="mt-6">Add custom branding</div>
              <div class="mt-6">Place batch scheduled orders</div>
              <div class="mt-6">Private design library</div>
            </div>
          </template>
          <div v-else class="pa-3">
            <router-link  @click.stop :to="{ name: 'pricing', hash: '#subscriptions' }">Learn more…</router-link>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>


<script>
import BuySubscriptionDialog from '@/components/BuySubscriptionDialog.vue';
import Price from '@/components/Price.vue';


const TIERS = [ ...[ ...Array(10).keys() ].map(i => `${i * 25 + 1} – ${(i + 1) * 25}`), '> 250' ];


export default {
  name: 'pricing-subscriptions',

  components: {
    BuySubscriptionDialog,
    Price
  },

  props: {
    collapse: Boolean,
    hideDescription: Boolean,
    showDetails: Boolean
  },

  data() {
    return {
      key: 'SINGLE-USER',
      tier: '1 – 25',
      buySubscription: null
    };
  },

  computed: {
    monthly() {
      // Happens to be $1 per user right now
      return (TIERS.indexOf(this.tier) + 1) * 25;
    }
  },

  created() {
    Object.assign(this, { TIERS });
  }
}
</script>
